module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDM0IDE4Ij4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPg0KICAgICAgICA8cGF0aCBkPSJNMSA5aDMyTTEgMWgzMk0xIDE3aDMyIi8+DQogICAgPC9nPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-menu.svg
// module id = XRQe
// module chunks = 1